import clearLocalStorage from '../lib/clear-local-storage';
import { gsap } from 'gsap';

import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import refreshTween from "../lib/refreshTween";

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

export default function init() {

    // Enable transitions after initial paint to avoid color flash on load
    const setReady = () => document.documentElement.classList.add('is-ready');

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', setReady, { once: true });
    } else {
        // DOMContentLoaded already fired
        setReady();
    }

    // Clear filters safely
    (() => {
        const el = document.querySelector('[data-postype]');
        const localStoragePostType = localStorage.getItem('postType');
        const currentPostType = el?.dataset?.postype || null;

        if (!currentPostType || currentPostType !== localStoragePostType) clearLocalStorage();
    })();

    //Anchors
    const siteHeader = document.querySelector("#site-header");
    const links = document.querySelectorAll("a");
    const currentUrl = window.location.origin + window.location.pathname;

    links.forEach((link) => {
        link.addEventListener("click", (event) => {
            const targetUrl = link.getAttribute("href");
            const targetHash = targetUrl.includes("#") ? targetUrl.split("#")[1] : null;

            if (!targetUrl || !targetHash) return;

            const isSamePage = targetUrl.startsWith("#") || targetUrl.startsWith(currentUrl + "#");

            if (link.getAttribute("target") === "_blank") return;

            event.preventDefault();

            setTimeout(() => {
                if (!isSamePage) {
                    window.location.href = targetUrl;
                } else {
                    const targetElement = document.getElementById(targetHash);
                    if (targetElement) {
                        gsap.to(window, {
                            duration: 1.5,
                            scrollTo: { y: targetElement, offsetY: siteHeader?.offsetHeight || 0 },
                            ease: "power2.inOut",
                        });
                    }
                }
            }, siteHeader.classList.contains("opened") ? 1500 : 0);
        });
    });

    // Scroll Animations
    const scrollAnimSelectors = 'section';

    document.querySelectorAll(scrollAnimSelectors).forEach((item) => {
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: item,
                start: 'top 90%',
                end: 'bottom top',
                invalidateOnRefresh: true,
                toggleActions: 'play none none none',
                onEnter() {
                    item.classList.add('scrolled');
                },
            },
        });
        refreshTween([tl]);
    });
}
